import React from 'react';
import { useNavigate } from 'react-router-dom';
import { infoPageStyles as styles } from './sharedStyles';
import { COLORS } from '../../constants';

const HelpCenter = () => {
  const navigate = useNavigate();

  const helpTopics = [
    { title: 'Getting Started', link: '/how-it-works', description: 'Learn how to use Redbird Markets' },
    { title: 'Safety Guidelines', link: '/safety-guidelines', description: 'Tips for safe transactions' },
    { title: 'Seller Resources', link: '/seller-resources', description: 'Best practices for selling' },
    { title: 'FAQ', link: '/faq', description: 'Common questions answered' },
    { title: 'Community Guidelines', link: '/community-guidelines', description: 'Rules and expectations' },
    { title: 'Dispute Resolution', link: '/dispute-resolution', description: 'Resolve transaction issues' }
  ];

  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Help Center</h1>
        <p style={styles.headerSubtitle}>We're here to help you succeed</p>
      </div>

      <div style={styles.contentContainer}>
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>How Can We Help You?</h2>
          <p style={styles.text}>
            Browse our help topics or search for specific answers below.
          </p>
        </div>

        {/* Help Topics Grid */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Popular Topics</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px'}}>
            {helpTopics.map((topic, idx) => (
              <div
                key={idx}
                style={{
                  background: `${COLORS.primary}08`,
                  border: `2px solid ${COLORS.primary}30`,
                  borderRadius: '12px',
                  padding: '20px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onClick={() => navigate(topic.link)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = COLORS.primary;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = `${COLORS.primary}30`;
                }}
              >
                <h3 style={{...styles.subsectionTitle, marginTop: 0, marginBottom: '8px'}}>{topic.title}</h3>
                <p style={{...styles.text, marginBottom: 0, fontSize: '14px'}}>{topic.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Quick Answers */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Quick Answers</h2>
          
          <div style={{marginBottom: '24px'}}>
            <h3 style={styles.subsectionTitle}>How do I create an account?</h3>
            <p style={styles.text}>
              Click "Sign Up" and use your ISU email address. Verify your email to access all features.
            </p>
          </div>

          <div style={{marginBottom: '24px'}}>
            <h3 style={styles.subsectionTitle}>How do I list an item for sale?</h3>
            <p style={styles.text}>
              Click "Sell" in the navigation, upload photos, add a description and price, then submit.
            </p>
          </div>

          <div style={{marginBottom: '24px'}}>
            <h3 style={styles.subsectionTitle}>How do I contact a seller?</h3>
            <p style={styles.text}>
              Click on any listing and use the "Message Seller" button to start a conversation.
            </p>
          </div>

          <div style={{marginBottom: '24px'}}>
            <h3 style={styles.subsectionTitle}>Is my information safe?</h3>
            <p style={styles.text}>
              Yes! We use encryption and secure payment processing. Read our <a href="/privacy-policy" style={styles.link}>Privacy Policy</a> for details.
            </p>
          </div>
        </div>

        {/* Contact Support */}
        <div style={{...styles.section, textAlign: 'center'}}>
          <h2 style={styles.sectionTitle}>Still Need Help?</h2>
          <p style={styles.text}>
            Our support team is ready to assist you with any questions or issues.
          </p>
          <button
            style={styles.button}
            onClick={() => navigate('/contact-us')}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 6px 20px ${COLORS.primary}40`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.primary}30`;
            }}
          >
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
